import { createPreset } from '@media-ui/pypo-article/src/containers/Article/presets/preset';
import type * as T from '../../Article.types';
import Products from '../../components/Products';
export const transform = (data: unknown) => {
    const typedData = data as T.IPetsProductPreset;
    return {
        titleBlock: typedData.attrs.name,
        items: typedData.data.products_group.products,
        textButton: typedData.attrs.button_text,
    };
};
export const presetPetsProduct = createPreset({
    type: 'petsproduct',
})(Products, transform);
